import { useRouter } from 'next/router';
import { useRef } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { specialsMap } from '@/data/ecocreditsday';
import { createEFPic } from '@/utils/useEFPic';
import CommonButton from '@/components/EcoCreditsDay/CommonButton';
import gtm from '@/utils/gtm';
import { signupCookie } from '@/utils/cookies/signupCookie';

const { EFPic } = createEFPic('/media/ecocredits-day/pc/');

export default function UseSpecials() {
    const { t } = useLang('ecocreditsday.pageTabs.tabB');
    const { t: t2 } = useLang('ecocreditsday');
    const { locale } = useRouter();
    const specialsData = specialsMap[locale as keyof typeof specialsMap] || specialsMap.jp;
    const cardRef = useRef<HTMLDivElement | null>(null);

    const cardScroll = (x = 0) => {
        cardRef.current?.scrollTo({ left: x, behavior: 'smooth' });
    };

    const handleClick = () => {
        if (!['jp'].includes(locale as string)) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'ecocredits_button',
                type: 'Other',
                list_name: t2('pageTabs.tab4'),
                button_name: t('useSpecials.btn_text'),
            });
        }
        const url =
            locale === 'jp'
                ? 'https://www.ecoflow.com/jp/register?redirect=https://www.ecoflow.com/jp/ecocredits'
                : `https://www.ecoflow.com/${locale}/ecocredits`;
        if (locale === 'jp') {
            signupCookie?.({
                sector_name: t('useSpecials.title'),
                entry_position: 6,
            });
        }
        window.open(url);
    };

    return (
        <div className={styles.useSpecials}>
            <div className="title-box">
                <div className="title">{t('useSpecials.title')}</div>
            </div>
            <div className="use-specials">
                {specialsData.length >= 4 && <div className="swiper-button swiper-button__prev" onClick={() => cardScroll(0)}></div>}
                <div className="card-box" ref={cardRef}>
                    {specialsData.map((item: Record<string, any>, i) => (
                        <div className={`card-item ${i === specialsData.length - 1 ? 'last-item' : ''}`} key={i}>
                            <div className="item-img">
                                <EFPic name={item.src} />
                            </div>
                            <div className="card-text">{item.title}</div>
                        </div>
                    ))}
                </div>
                {specialsData.length >= 4 && <div className="swiper-button swiper-button__next" onClick={() => cardScroll(1000)}></div>}
            </div>
            <div className="btn-box">
                <div className="inline-block__btn">
                    <CommonButton padding="9px 15px" borderRadius="8px" isLoop disabledAni onClick={handleClick}>
                        <div className="btn">
                            {t('useSpecials.btn_text')}
                            <div className="btn-svg"></div>
                        </div>
                    </CommonButton>
                </div>
            </div>
        </div>
    );
}
